import { ReactNode } from "react";
import { BoxStyles } from "./style";

interface ModalHeaderProps {
  children: ReactNode;
  justifyContent?: string;
  minHeight?: string;
}
export function ModalHeader({
  children,
  justifyContent,
  minHeight,
}: ModalHeaderProps) {
  return (
    <BoxStyles justifyContent={justifyContent} minHeight={minHeight}>
      {children}
    </BoxStyles>
  );
}
